import { render, staticRenderFns } from "./NewItemMaintenance.vue?vue&type=template&id=c8138f3c&"
import script from "./NewItemMaintenance.vue?vue&type=script&lang=js&"
export * from "./NewItemMaintenance.vue?vue&type=script&lang=js&"
import style0 from "./NewItemMaintenance.vue?vue&type=style&index=0&id=c8138f3c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports